import { MoveLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import Padlock from "~/assets/images/Animation.png";

import { Button } from "../ui";

const NoAccess = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen w-full">
      <div className="flex h-full items-center justify-center py-48">
        <div className="">
          <img src={Padlock} alt="" className="h-50 w-50 mx-auto mb-6" />
          <div className="text-center">
            <h1 className="font-Bold text-3xl">Access Denied</h1>
            <p className="mt-5 text-sm">
              It seems like you dont have the required
            </p>
            <p className="text-sm"> permissions to view this content.</p>
          </div>
          <Button
            className="w-full gap-x-2 sm:w-auto"
            onClick={() => navigate(-1)}
          >
            <MoveLeft className="text-secondary-500" />
            Back
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NoAccess;
